module.exports = __webpack_public_path__ + "static/bike-4e3b9dc18264afd4db062afb7ad5042b.jpg";